<div class="builder-screen-root" [attr.data-screen-size]="screenSize$ | async">

<app-sticky-action-bar 
[currentTemplateId]="currentTemplateId"
(openTemplateManager)="openTemplateManager()"
(openAutoScreenGenerator)="openAutoScreenGenerator()"
(openOptimizedAutoScreenGenerator)="openOptimizedAutoScreenGenerator()"
(openSaveTemplateModal)="openSaveTemplateModal()"
(openLauncherModal)="openLauncherModal()">
</app-sticky-action-bar>

<div class="builder-workspace" [class.preview-mode]="isPreviewMode$ | async">

<div class="palette-section" [class.collapsed]="isPaletteCollapsed">
  <div class="section-header">
    <h3>{{ 'builderScreen.palette.title' |translateTA }}</h3>
    <button 
      nz-button 
      nzType="text" 
      nzSize="small"
      (click)="togglePalette()"
      [nz-tooltip]="isPaletteCollapsed ? 'builderScreen.palette.expand' : 'builderScreen.palette.collapse' |translateTA">
      <nz-icon [nzType]="isPaletteCollapsed ? 'menu-unfold' : 'menu-fold'" nzTheme="outline"></nz-icon>
    </button>
  </div>
  <div class="section-content" [class.hidden]="isPaletteCollapsed">
    <app-builder-palette-beta></app-builder-palette-beta>
  </div>
</div>


<div class="canvas-section">
  <div class="section-header">
    <h3>{{ 'builderScreen.canvas.title' |translateTA }}</h3>
    <div class="canvas-controls">
      <button 
        nz-button 
        nzType="text" 
        nzSize="small"
        (click)="toggleGrid()"
        [class.active]="isGridVisible$ | async"
        [nz-tooltip]="'builderScreen.canvas.toggleGrid' |translateTA">
        <nz-icon nzType="border" nzTheme="outline"></nz-icon>
      </button>
      <button 
        nz-button 
        nzType="text" 
        nzSize="small"
        (click)="togglePreview()"
        [class.active]="isPreviewMode$ | async"
        [nz-tooltip]="'builderScreen.canvas.togglePreview' |translateTA">
        <nz-icon nzType="eye" nzTheme="outline"></nz-icon>
      </button>
    </div>
  </div>
  <div class="section-content canvas-container" 
       [style.transform]="'scale(' + (zoom$ | async) + ')'"
       [class.grid-visible]="isGridVisible$ | async">
    <app-builder-canvas-beta (componentSelected)="onComponentSelected($event)"></app-builder-canvas-beta>
  </div>
</div>

<!-- Inspetor Legado (visível apenas no modo legado) -->
<div class="inspector-section legacy" 
     [class.hidden]="(uiState.layout$ | async)?.mode !== 'legacy'"
     [class.collapsed]="isInspectorCollapsed">
  <div class="section-header">
    <h3>{{ 'builderScreen.inspector.title' |translateTA }}</h3>
    <button 
      nz-button 
      nzType="text" 
      nzSize="small"
      (click)="toggleInspector()"
      [nz-tooltip]="isInspectorCollapsed ? 'builderScreen.inspector.expand' : 'builderScreen.inspector.collapse' |translateTA">
      <nz-icon [nzType]="isInspectorCollapsed ? 'menu-unfold' : 'menu-fold'" nzTheme="outline"></nz-icon>
    </button>
  </div>
  <div class="section-content" [class.hidden]="isInspectorCollapsed">
    <app-builder-inspector-beta></app-builder-inspector-beta>
  </div>
</div>
</div>


<div class="json-section" [class.collapsed]="isJsonCollapsed">
<div class="section-header">
  <h3>{{ 'builderScreen.jsonPreview.title' |translateTA }}</h3>
  <button 
    nz-button 
    nzType="text" 
    nzSize="small"
    (click)="toggleJson()"
    [nz-tooltip]="isJsonCollapsed ? 'builderScreen.jsonPreview.expand' : 'builderScreen.jsonPreview.collapse' |translateTA">
    <nz-icon [nzType]="isJsonCollapsed ? 'up' : 'down'" nzTheme="outline"></nz-icon>
  </button>
</div>
<div class="section-content" [class.hidden]="isJsonCollapsed">
  <app-builder-json-preview-beta [jsonText]="(builderService.jsonText$ | async) ?? '{ }'"></app-builder-json-preview-beta>
</div>
</div>

<!-- Template Selector Inline (como o inspector-mode-toggle) -->
<div class="template-selector-section" [class.collapsed]="!showTemplateSelector">
<div class="section-header">
  <h3>Templates de Telas</h3>
  <button 
    nz-button 
    nzType="text" 
    nzSize="small"
    (click)="toggleTemplateSelector()"
    [nz-tooltip]="showTemplateSelector ? 'Ocultar Templates' : 'Mostrar Templates'">
    <nz-icon [nzType]="showTemplateSelector ? 'up' : 'down'" nzTheme="outline"></nz-icon>
  </button>
</div>
<div class="section-content" [class.hidden]="!showTemplateSelector">
  <app-template-selector
    #templateSelector
    [templates]="availableTemplates"
    [loading]="false"
    (templateSelected)="onTemplateApplied($event)"
    (templateApplied)="onTemplateApplied($event)"
    (templatePreviewed)="onTemplateApplied($event)"
    (templateDuplicated)="handleTemplateDuplicate($event)">
  </app-template-selector>
</div>
</div>
</div>

<!-- Inspetor Flutuante (visível apenas no modo flutuante) -->
<app-floating-inspector 
*ngIf="(uiState.layout$ | async)?.mode === 'floating'"
[selectedNode]="selectedNode$ | async">
</app-floating-inspector>

<!-- Inspetor Acoplado (visível apenas no modo acoplado) -->
<nz-drawer 
*ngIf="(uiState.layout$ | async)?.mode === 'docked'"
[nzVisible]="(uiState.inspectorVisible$ | async) || false"
[nzClosable]="true"
nzPlacement="right"
[nzWidth]="400"
[nzTitle]="'builderScreen.inspector.title' |translateTA"
(nzOnClose)="onCloseDocked()">


<div class="docked-inspector-content">

<div class="inspector-mode-section">
  <app-inspector-mode-toggle></app-inspector-mode-toggle>
</div>


<app-builder-inspector-beta></app-builder-inspector-beta>
</div>
</nz-drawer>


<!-- TEMPORARIAMENTE DESABILITADO: Edição Rápida causando problemas com drag & drop -->
<!-- <app-inline-editor></app-inline-editor> -->


<app-feature-guide #featureGuide></app-feature-guide>


<app-property-presets-modal 
#presetsModal
[componentType]="(builderService.selectedNode$ | async)?.type || null"
[selectedNode]="builderService.selectedNode$ | async">
</app-property-presets-modal>


<app-ai-suggestions-panel 
#aiSuggestionsPanel
[componentType]="(builderService.selectedNode$ | async)?.type || null"
[selectedNode]="builderService.selectedNode$ | async">
</app-ai-suggestions-panel>

<!-- Modal de Seleção de Templates REMOVIDO - agora funciona inline como inspector-mode-toggle -->

<!-- Drawer de Gerenciamento de Templates do Banco -->
<nz-drawer
  [nzVisible]="showTemplateManagerDrawer"
  nzPlacement="right"
  [nzTitle]="'builderScreen.templates.savedTitle' | translateTA"
  [nzWidth]="720"
  (nzOnClose)="closeTemplateManager()">
  
  <ng-container *nzDrawerContent>
    <div class="template-manager-content">
      
      <!-- Header com botão novo template -->
      <div class="manager-header">
        <button nz-button nzType="primary" (click)="createNewTemplate()">
          <nz-icon nzType="plus"></nz-icon>
          Novo Template
        </button>
        
        <nz-tag [nzColor]="'blue'" *ngIf="savedTemplates.length > 0">
          {{ savedTemplates.length }} templates salvos
        </nz-tag>
      </div>

      <!-- Componente template-selector reutilizado -->
      <nz-spin [nzSpinning]="loadingTemplates" [nzTip]="'builderScreen.templates.loading' | translateTA">
        <app-template-selector
          *ngIf="!loadingTemplates"
          [templates]="savedTemplates"
          [loading]="loadingTemplates"
          (templateApplied)="loadSavedTemplate($event)"
          (templateDeleted)="handleTemplateDelete($event)"
          (templateDuplicated)="handleTemplateDuplicate($event)">
        </app-template-selector>

        <nz-empty 
          *ngIf="!loadingTemplates && savedTemplates.length === 0"
          [nzNotFoundContent]="'builderScreen.templates.none' | translateTA">
        </nz-empty>
      </nz-spin>
      
    </div>
  </ng-container>
</nz-drawer>

<!-- Modal para salvar template -->
<nz-modal 
[(nzVisible)]="showTemplateSaveModal" 
[nzTitle]="currentTemplateId ? 'Atualizar Template' : 'Salvar Novo Template'" 
nzWidth="600px" 
(nzOnCancel)="showTemplateSaveModal = false" 
(nzOnOk)="onSaveTemplate()"
[nzOkText]="currentTemplateId ? 'Atualizar' : 'Salvar'">
<ng-container *nzModalContent>
<form nz-form [nzLayout]="'vertical'">
  <nz-form-item>
    <nz-form-label nzRequired>Nome do Template</nz-form-label>
    <nz-form-control>
      <input 
        nz-input 
        [(ngModel)]="templateFormData.name" 
        name="name" 
        [placeholder]="'builderScreen.templates.nameExample' | translateTA" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>{{ 'builderScreen.common.description' | translateTA }}</nz-form-label>
    <nz-form-control>
      <textarea 
        nz-input 
        [(ngModel)]="templateFormData.description" 
        name="description" 
        [nzAutosize]="{ minRows: 3, maxRows: 6 }" 
        [placeholder]="'builderScreen.templates.descPlaceholder' | translateTA">
      </textarea>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzRequired>Categoria</nz-form-label>
    <nz-form-control>
      <nz-select [(ngModel)]="templateFormData.category" name="category">
        <nz-option nzValue="product" [nzLabel]="'builderScreen.templates.category.products' | translateTA"></nz-option>
        <nz-option nzValue="partner" [nzLabel]="'builderScreen.templates.category.partners' | translateTA"></nz-option>
        <nz-option nzValue="marketplace" [nzLabel]="'builderScreen.templates.category.marketplaces' | translateTA"></nz-option>
        <nz-option nzValue="custom" [nzLabel]="'builderScreen.templates.category.custom' | translateTA"></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-control>
      <label nz-checkbox [(ngModel)]="templateFormData.isPublic" name="isPublic">
        Tornar template público
      </label>
      <div class="form-help">
        <small>{{ 'builderScreen.templates.publicHint' | translateTA }}</small>
      </div>
    </nz-form-control>
  </nz-form-item>
</form>
</ng-container>
</nz-modal>

<!-- Modal de Criação de Lançador de Tela -->
<nz-modal 
[(nzVisible)]="showLauncherModal"
[nzTitle]="'builderScreen.launcher.createTitle' | translateTA"
nzWidth="700px"
[nzOkText]="'Criar Lançador'"
[nzCancelText]="'Cancelar'"
(nzOnCancel)="showLauncherModal = false"
(nzOnOk)="onCreateLauncher()">
<ng-container *nzModalContent>
<nz-alert
  nzType="info"
  [nzMessage]="'builderScreen.launcher.createTitle' | translateTA"
  [nzDescription]="'builderScreen.launcher.createHint' | translateTA"
  [nzCloseable]="false"
  nzShowIcon
  style="margin-bottom: 24px;">
</nz-alert>

<form nz-form [nzLayout]="'vertical'">
  
  <nz-form-item>
    <nz-form-label nzRequired>{{ 'builderScreen.launcher.name' | translateTA }}</nz-form-label>
    <nz-form-control [nzErrorTip]="'builderScreen.launcher.nameRequiredTip' | translateTA">
      <input 
        nz-input 
        [(ngModel)]="launcherFormData.name" 
        name="name"
        (ngModelChange)="onLauncherNameChange()"
        [placeholder]="'builderScreen.templates.nameExample' | translateTA" />
      <nz-form-text>
        <small>{{ 'builderScreen.launcher.nameHint' | translateTA }}</small>
      </nz-form-text>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>{{ 'builderScreen.common.description' | translateTA }}</nz-form-label>
    <nz-form-control>
      <textarea 
        nz-input 
        [(ngModel)]="launcherFormData.description" 
        name="description"
        [nzAutosize]="{ minRows: 2, maxRows: 4 }"
        [placeholder]="'builderScreen.launcher.descPlaceholder' | translateTA"></textarea>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzRequired>Caminho da Rota</nz-form-label>
    <nz-form-control [nzErrorTip]="'builderScreen.launcher.routeRequiredTip' | translateTA">
      <input 
        nz-input 
        [(ngModel)]="launcherFormData.routePath" 
        name="routePath"
        [placeholder]="'builderScreen.launcher.routeExample' | translateTA" />
      <nz-form-text>
        <small>{{ 'builderScreen.launcher.urlWillBe' | translateTA }} <code>/{{ launcherFormData.routePath || '...' }}</code></small>
        <br>
        <small style="color: #999;">{{ 'builderScreen.launcher.routeCharsHint' | translateTA }}</small>
      </nz-form-text>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>Menu Pai</nz-form-label>
    <nz-form-control>
      <nz-select
        [(ngModel)]="launcherFormData.parentMenuId"
        name="parentMenuId"
        [nzPlaceHolder]="'builderScreen.launcher.parentPlaceholder' | translateTA"
        [nzLoading]="loadingMenuTree"
        nzShowSearch
        nzAllowClear>
        <nz-option 
          *ngFor="let menu of menuTreeData" 
          [nzValue]="menu.key" 
          [nzLabel]="menu.title">
        </nz-option>
      </nz-select>
      <nz-form-text>
        <small>Deixe em branco para aparecer no menu raiz</small>
      </nz-form-text>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>{{ 'builderScreen.inspector.icon' | translateTA }}</nz-form-label>
    <nz-form-control>
      <nz-select 
        [(ngModel)]="launcherFormData.iconName" 
        name="iconName"
        nzShowSearch
        [nzLoading]="loadingCustomIcons"
        [nzPlaceHolder]="'builderScreen.tabs.icon.placeholder' | translateTA"
        [nzCustomTemplate]="iconTemplate">
        
        <!-- Ícones Padrão (Ant Design) -->
        <nz-option-group [nzLabel]="'builderScreen.launcher.iconGroup.standard' | translateTA">
          <nz-option nzValue="form" [nzLabel]="'builderScreen.launcher.icon.form' | translateTA" nzCustomContent>
            <nz-icon nzType="form" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">{{ 'builderScreen.launcher.icon.form' | translateTA }}</span>
          </nz-option>
          <nz-option nzValue="layout" [nzLabel]="'builderScreen.launcher.icon.layout' | translateTA" nzCustomContent>
            <nz-icon nzType="layout" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">Layout</span>
          </nz-option>
          <nz-option nzValue="appstore" [nzLabel]="'builderScreen.launcher.icon.app' | translateTA" nzCustomContent>
            <nz-icon nzType="appstore" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">App</span>
          </nz-option>
          <nz-option nzValue="setting" [nzLabel]="'builderScreen.launcher.icon.settings' | translateTA" nzCustomContent>
            <nz-icon nzType="setting" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">{{ 'builderScreen.launcher.icon.settings' | translateTA }}</span>
          </nz-option>
          <nz-option nzValue="file-text" [nzLabel]="'builderScreen.launcher.icon.document' | translateTA" nzCustomContent>
            <nz-icon nzType="file-text" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">Documento</span>
          </nz-option>
          <nz-option nzValue="database" [nzLabel]="'builderScreen.launcher.icon.data' | translateTA" nzCustomContent>
            <nz-icon nzType="database" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">Dados</span>
          </nz-option>
          <nz-option nzValue="container" [nzLabel]="'builderScreen.launcher.icon.container' | translateTA" nzCustomContent>
            <nz-icon nzType="container" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">Container</span>
          </nz-option>
          <nz-option nzValue="edit" [nzLabel]="'builderScreen.common.edit' | translateTA" nzCustomContent>
            <nz-icon nzType="edit" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">Editar</span>
          </nz-option>
          <nz-option nzValue="plus-square" [nzLabel]="'builderScreen.common.add' | translateTA" nzCustomContent>
            <nz-icon nzType="plus-square" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">Adicionar</span>
          </nz-option>
          <nz-option nzValue="shopping-cart" [nzLabel]="'builderScreen.launcher.icon.cart' | translateTA" nzCustomContent>
            <nz-icon nzType="shopping-cart" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">Carrinho</span>
          </nz-option>
          <nz-option nzValue="home" [nzLabel]="'builderScreen.launcher.icon.home' | translateTA" nzCustomContent>
            <nz-icon nzType="home" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">Home</span>
          </nz-option>
          <nz-option nzValue="user" [nzLabel]="'builderScreen.launcher.icon.user' | translateTA" nzCustomContent>
            <nz-icon nzType="user" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">{{ 'builderScreen.launcher.icon.user' | translateTA }}</span>
          </nz-option>
          <nz-option nzValue="team" [nzLabel]="'builderScreen.launcher.icon.team' | translateTA" nzCustomContent>
            <nz-icon nzType="team" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">Equipe</span>
          </nz-option>
          <nz-option nzValue="project" [nzLabel]="'builderScreen.launcher.icon.project' | translateTA" nzCustomContent>
            <nz-icon nzType="project" nzTheme="outline"></nz-icon>
            <span style="margin-left: 8px;">Projeto</span>
          </nz-option>
        </nz-option-group>
        
        <!-- Ícones Customizados (MKTPICONS) -->
        <nz-option-group [nzLabel]="'builderScreen.launcher.iconGroup.custom' | translateTA" *ngIf="customIcons.length > 0">
          <nz-option 
            *ngFor="let icon of customIcons" 
            [nzValue]="icon.name" 
            [nzLabel]="icon.displayName"
            nzCustomContent>
            <nz-icon [nzType]="icon.name" style="font-size: 18px; margin-right: 8px; vertical-align: middle;"></nz-icon>
            <span>{{ icon.displayName }}</span>
          </nz-option>
        </nz-option-group>
        
      </nz-select>
      
      <!-- Template para mostrar ícone selecionado -->
      <ng-template #iconTemplate let-selected>
        <ng-container *ngIf="!selected.nzValue.startsWith('custom:')">
          <nz-icon [nzType]="selected.nzValue" nzTheme="outline"></nz-icon>
          <span style="margin-left: 8px;">{{ selected.nzLabel }}</span>
        </ng-container>
        <ng-container *ngIf="selected.nzValue.startsWith('custom:')">
          <!-- Usar selected.nzValue (já no formato "custom:NOME" registrado no NzIconService) -->
          <nz-icon [nzType]="selected.nzValue" style="font-size: 18px; margin-right: 8px; vertical-align: middle;"></nz-icon>
          <span>{{ selected.nzLabel }}</span>
        </ng-container>
      </ng-template>
      
      <nz-form-text>
        <small>{{ 'builderScreen.launcher.customIconsHint' | translateTA }}</small>
      </nz-form-text>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>Ordem no Menu</nz-form-label>
    <nz-form-control>
      <nz-input-number 
        [(ngModel)]="launcherFormData.menuOrder" 
        name="menuOrder"
        [nzMin]="0"
        [nzMax]="999"
        nzPlaceHolder="0"
        style="width: 150px;"></nz-input-number>
      <nz-form-text>
        <small>{{ 'builderScreen.launcher.orderHint' | translateTA }}</small>
      </nz-form-text>
    </nz-form-control>
  </nz-form-item>

  <!-- NOVO: Seção Data Source -->
  <nz-divider [nzText]="'builderScreen.launcher.dataSourceSection' | translateTA"></nz-divider>
  
  <nz-form-item>
    <nz-form-label>{{ 'builderScreen.launcher.dataConfig' | translateTA }}</nz-form-label>
    <nz-form-control>
      <nz-space nzDirection="vertical" style="width: 100%;">
        <div *nzSpaceItem style="display: flex; align-items: center; gap: 8px;">
          <nz-tag [nzColor]="getDataSourceColor()">
            {{ getDataSourceLabel() }}
          </nz-tag>
          <button nz-button nzType="link" (click)="openDataSourceConfig()">
            <i nz-icon nzType="setting"></i> Configurar Fonte de Dados
          </button>
        </div>
      </nz-space>
      <nz-form-text>
        <small>{{ 'builderScreen.launcher.dataSourceHint' | translateTA }}</small>
      </nz-form-text>
    </nz-form-control>
  </nz-form-item>

</form>
</ng-container>
</nz-modal>

<!-- Data Source Config Modal -->
<app-data-source-config
  [(visible)]="showDataSourceConfigModal"
  [config]="currentDataSourceConfig"
  (configChange)="handleDataSourceConfigChange($event)">
</app-data-source-config>

<!-- Auto Screen Generator Modal -->
<app-auto-screen-generator
[(visible)]="autoScreenGeneratorVisible"
(screenGenerated)="onScreenGenerated($event)">
</app-auto-screen-generator>

<!-- ⚡ NOVO: Gerador Otimizado de Telas -->
<app-optimized-auto-screen-generator
[(visible)]="optimizedAutoScreenGeneratorVisible"
(screenGenerated)="onOptimizedScreenGenerated($event)">
</app-optimized-auto-screen-generator>